import { render } from "./SearchAndUserInfo.vue?vue&type=template&id=030afefe&scoped=true&ts=true"
import script from "./SearchAndUserInfo.vue?vue&type=script&lang=ts"
export * from "./SearchAndUserInfo.vue?vue&type=script&lang=ts"

import "./SearchAndUserInfo.vue?vue&type=style&index=0&id=030afefe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030afefe"]])

export default __exports__